import moment from "moment";
export function display_date(value, strFormat) {
  // Giả định value là GMT, chuyển sang GMT+7 khi hiển thị
  return value ? moment.utc(value).utcOffset(7 * 60).format(strFormat ? strFormat : 'DD-MM-YYYY HH:mm:ss') : '';
}

import config from '../configs'
export function order_status(value, type = 0){
  const objStatus = type == 0 ? config.ORDER_STATUS.find(obj => obj.value === value) : config.ORDER_DEPOSIT_STATUS.find(obj => obj.value === value);
  if (!objStatus && value === 3) return 'Chờ báo giá';
  return objStatus ? objStatus.name : '';
}

export function order_status_color(value, type = 0){
  const objStatus = type == 0 ? config.ORDER_STATUS.find(obj => obj.value === value) : config.ORDER_DEPOSIT_STATUS.find(obj => obj.value === value);
  if (!objStatus && value === 3) return '#8B5CF6';
  return objStatus ? objStatus.color : 'black';
}

export function order_status_text_color(value, type = 0){
  const objStatus = type == 0 ? config.ORDER_STATUS.find(obj => obj.value === value) : config.ORDER_DEPOSIT_STATUS.find(obj => obj.value === value);
  if (!objStatus && value === 3) return '#ffffff';
  return objStatus ? objStatus.textColor : 'black';
}

export function vip_level(value){
  const objRet = config.VIP_LEVEL.find(obj => obj.value === value);
  return objRet ? objRet.name : '';
}

export function vip_level_color(value){
  const objRet = config.VIP_LEVEL.find(obj => obj.value === value);
  return objRet ? objRet.color : '';
}

export function capitalize(value){
  return value.toLowerCase().replace(/^.|\s\S/g, function(a) { return a.toUpperCase(); });
};

export function display_value(value, enums, key_field = 'value', value_field = 'name') {
  const item = enums.find(obj => obj[key_field] === value);
  return item ? item[value_field] : '';
}

export function display_color(value, enums) {
  const item = enums.find(obj => obj.value === value);
  return item ? item.color : '';
}

export function display_text_color(value, enums) {
  const item = enums.find(obj => obj.value === value);
  return item ? item.textColor : '';
}